export function getPluralForm(count, endings) {
  const cases = [2, 0, 1, 1, 1, 2];
  return endings[
    count % 100 > 4 && count % 100 < 20 ? 2 : cases[Math.min(count % 10, 5)]
  ];
}
